import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { clearAuthToken, setAuthToken } from './auth';
import { Initialize, RootProvider } from './utils';

export const App = () => {
  const [sessionValidationKey, setSessionValidationKey] = useState(0);
  const [isValidSession, setIsValidSession] = useState(false);
  const queryClient = useQueryClient();

  const invalidateSession = async () => {
    await clearAuthToken();
    setIsValidSession(false);
    queryClient.clear();
  };

  const setSession = async (sessionToken: string) => {
    await setAuthToken(sessionToken);
  };

  return (
    <RootProvider
      retryVerifySession={() => setSessionValidationKey(Date.now())}
      setSession={setSession}
      removeLocalSession={invalidateSession}
    >
      <Initialize
        sessionValidationKey={sessionValidationKey}
        isValidSession={isValidSession}
        onValidSessionChanged={setIsValidSession}
      />
    </RootProvider>
  );
};
